import { buildValidations, validator } from 'ember-cp-validations';
import { reads } from '@ember/object/computed';
import Super from './treatable-client';
import classic from 'ember-classic-decorator';
import moment from 'moment-timezone';

const Validations = buildValidations({
  clientRelationships: validator('has-many'),
  firstName: validator('presence', {
    presence: true,
    ignoreBlank: true,
    message: 'First name is required',
    disabled: reads('model.skipContactFormSpecificValidations'),
  }),
  lastName: validator('presence', {
    presence: true,
    ignoreBlank: true,
    message: 'Last name is required',
    disabled: reads('model.skipContactFormSpecificValidations'),
  }),
  birthDate: [
    validator('presence', {
      presence: true,
      disabled: reads('model.skipContactFormSpecificValidations'),
    }),
    validator('inline', {
      validate(value) {
        if (!value || value.isBefore(moment())) return true;

        return 'Please enter a valid date of birth.';
      },
    }),
  ],
  state: validator('presence', {
    presence: true,
    message: 'State is required',
    disabled: reads('model.skipContactFormSpecificValidations'),
  }),
});

@classic
export default class ClientCouple extends Super.extend(Validations) {
  isCouple = true;
  skipContactFormSpecificValidations = true;
}
